import Config from '../definitions/Config';
import fetchJSON from './fetchJSON';


const API_ENDPOINT = `${Config.PROFILE_BFF_URL}/magic-request`;

/**
 *
 * @param {string} email
 * @param {Object} queryParams
 * @param {string} queryParams.lang
 * @param {Object} documentOptions
 * @param {Object=} documentOptions.document
 * @param {string=} documentOptions.documentType
 * @param {string=} documentOptions.documentRedirect
 * @param {string=} variant
 * @param {number=} delay
 * @returns {Promise<*>}
 */
function requestMagicLink({
    email,
    queryParams,
    documentOptions,
    variant,
    delay = 0,
}) {
    if (!email) {
        throw new Error(`Email is required to request a magic link. received: ${email}`);
    }

    const { lang, ...otherQueryParams } = queryParams ?? {};

    const { document, documentType, documentRedirect } = documentOptions ?? {};

    // Error handling occurs within fetchJSON
    return fetchJSON({
        url: API_ENDPOINT,
        options: {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                email,
                queryParams: otherQueryParams,
                document,
                documentType,
                documentRedirect,
                variant,
                lang,
                delay,
            }),
            credentials: 'include',
        },
    }, 'requestMagicLink');
}

export {
    requestMagicLink,
    API_ENDPOINT,
};
